var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawQuestions52Ic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 676.854,
    viewBox: "0 0 960 676.854",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-537.662 -242.369)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.28,
    cy: 52.28,
    r: 52.28,
    transform: "translate(975.673 812.908)",
    fill: "#adef2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.4,818.129c29.248-8.784,60.343-17.943,83.539-38.825,20.728-18.66,34.721-47.154,26.134-75.138-8.569-27.927-34.237-46.548-60.738-55.81-15.031-5.253-30.755-8.167-46.474-10.456-17.088-2.489-34.251-4.528-51.406-6.49Q810.258,619.493,705.28,616.85c-34.533-.87-69.06-.849-103.6-.347-30.845.448-63.33.437-91.944-12.673-22.252-10.194-42.447-28.742-48.647-53.114-7.157-28.134,6.044-56.785,24.981-77.161,9.982-10.74,21.648-19.78,33.682-28.092,13.056-9.017,26.567-17.4,40.371-25.217A562.168,562.168,0,0,1,645.1,381.07c14.485-5.267,29.186-9.811,44.015-14,12.521-3.54,25.081-7.085,37.183-11.908,23.394-9.324,45.644-25.117,51.592-51.009,5.638-24.539-3.868-51.179-20.531-69.409-19.279-21.091-48.347-30.336-76.216-31.832-31.287-1.679-61.853,6.151-91.26,16.089-31.365,10.6-62.053,22.787-94.08,31.372a633,633,0,0,1-96.828,18c-16,1.7-32.494,3.629-48.594,2.324-13.493-1.093-26.918-5.062-36.862-14.638-8.527-8.211-13.606-19.5-11.86-31.405.317-2.163,3.6-1.243,3.288.906-2.126,14.5,7.728,27.855,19.871,34.7,14.034,7.908,31.112,7.919,46.736,7.015a611.272,611.272,0,0,0,100.6-14.543c32.5-7.422,63.832-18.033,95.132-29.367,29.727-10.765,60.119-21.271,91.877-23.6,27.556-2.023,56.544,1.991,80.551,16.392,21.1,12.656,36.613,33.763,41.557,57.984,4.831,23.668-1.86,47.49-19.776,64.006-18.55,17.1-43.985,24.412-67.688,31.145-30.064,8.54-59.483,18.523-87.959,31.485a552.159,552.159,0,0,0-82.739,46.516c-25.284,17.278-50.236,39.018-58.232,69.841-3.725,14.358-3.037,29.586,3.2,43.148,5.542,12.059,14.669,22.2,25.3,30.025,25.368,18.667,57.341,22.5,87.984,22.881,34.416.428,68.833-.733,103.26-.168q105.242,1.727,210.052,12.812,26.263,2.78,52.46,6.145c15.709,2.018,31.47,4.024,46.914,7.609,27.461,6.374,54.183,18.63,71.251,41.913a69.692,69.692,0,0,1,13.578,34.6c1.195,13.1-2.011,26.219-7.933,37.87-13.107,25.788-37.657,42.191-63.729,52.968-13.964,5.772-28.449,10.145-42.906,14.486-2.106.632-3.006-2.657-.906-3.288Z",
    transform: "translate(376.883 96.403)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.277,
    cy: 27.277,
    r: 27.277,
    transform: "translate(653.466 294.081)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.277,
    cy: 27.277,
    r: 27.277,
    transform: "translate(842.699 345.794)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.277,
    cy: 27.277,
    r: 27.277,
    transform: "translate(1002.95 242.369)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.277,
    cy: 27.277,
    r: 27.277,
    transform: "translate(1102.964 358.295)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.277,
    cy: 27.277,
    r: 27.277,
    transform: "translate(967.717 492.406)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.277,
    cy: 27.277,
    r: 27.277,
    transform: "translate(796.101 557.188)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.277,
    cy: 27.277,
    r: 27.277,
    transform: "translate(977.946 658.34)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.277,
    cy: 27.277,
    r: 27.277,
    transform: "translate(1173.429 715.166)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.277,
    cy: 27.277,
    r: 27.277,
    transform: "translate(1401.872 702.664)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.121,220.373c-81.707.577-148.608,66.976-149.769,148.677-.011.754-.016,6.058-.015,13A38.355,38.355,0,0,0,510.686,420.4h0a38.377,38.377,0,0,0,38.371-38.4c0-4.727-.006-7.994-.006-8.194a72.738,72.738,0,1,1,111.972,61.236l.013.016S606.451,470.194,589.81,518.4l.014,0a106.843,106.843,0,0,0-4.4,30.423c0,4.234.249,41.28.73,71.349a39.536,39.536,0,0,0,39.54,38.895h0a39.547,39.547,0,0,0,39.544-39.791c-.167-27.537-.258-59.6-.258-61.929,0-29.6,28.556-59.094,52.012-78.327,27.011-22.148,46.448-52.329,54.255-86.375a98.611,98.611,0,0,0,2.841-21.4A150.874,150.874,0,0,0,622.121,220.373Z",
    transform: "translate(400.232 99.284)",
    fill: "#adef2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.309,747.956H179.016a1.353,1.353,0,1,1,0-2.706h957.293a1.353,1.353,0,1,1,0,2.706Z",
    transform: "translate(360 170.947)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.581,394.755h0a38.355,38.355,0,0,1-38.351-38.349c0-6.941,0-12.245.015-13A149.461,149.461,0,0,1,500.7,275.319a149.8,149.8,0,0,0-28.821,86.273c-.011.754-.016,6.058-.015,13a38.355,38.355,0,0,0,38.349,38.353h0a38.384,38.384,0,0,0,36.923-27.948A38.213,38.213,0,0,1,521.581,394.755Z",
    transform: "translate(400.168 106.786)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.483,293.673a72.742,72.742,0,0,1,63.258,101.621,72.735,72.735,0,1,0-122.093-76.131,72.591,72.591,0,0,1,58.834-25.49Z",
    transform: "translate(411.47 106.798)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623,609.04h0a39.538,39.538,0,0,1-39.54-38.9c-.481-30.06-.73-67.106-.73-71.34a106.841,106.841,0,0,1,4.4-30.423l-.014,0a108.037,108.037,0,0,1,6.244-14.435,125.074,125.074,0,0,0-17.609,32.62l.014,0a106.841,106.841,0,0,0-4.4,30.423c0,4.234.249,41.28.73,71.349a39.536,39.536,0,0,0,39.54,38.895h0a39.552,39.552,0,0,0,37.96-28.462A39.392,39.392,0,0,1,623,609.04Z",
    transform: "translate(413.753 131.173)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.828,744.91a52.273,52.273,0,0,1-19.4-81.249A52.277,52.277,0,1,0,655.539,739.2a52.246,52.246,0,0,1-51.711,5.711Z",
    transform: "translate(412.607 159.807)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1135.87 516.267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.847,101.451l-18.867,6.2V80.5H273.1Z",
    transform: "translate(-207.812 -42.416)",
    fill: "#f8a8ab"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.799,
    cy: 18.799,
    rx: 18.799,
    ry: 18.799,
    transform: "translate(31.706 8.004)",
    fill: "#f8a8ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.955,60.3c-3.147-.093-5.215-3.274-6.434-6.176s-2.48-6.236-5.4-7.433c-2.388-.979-6.6,5.645-8.479,3.881-1.966-1.84-.05-11.283,2.034-12.977s4.936-2.025,7.62-2.151a78.078,78.078,0,0,1,19.559,1.569c3.974.827,8.058,2.076,10.926,4.942,3.628,3.645,4.556,9.139,4.818,14.277.27,5.257-.034,10.757-2.591,15.357s-7.906,7.991-13.036,6.818c-.515-2.784.008-5.645.211-8.479s-.008-5.881-1.738-8.133-5.417-3.147-7.425-1.148",
    transform: "translate(-205.287 -35.364)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.721,72.216c1.882-1.375,4.135-2.531,6.446-2.245a6.5,6.5,0,0,1,5.257,4.8,8.349,8.349,0,0,1-1.628,7.113,11.784,11.784,0,0,1-6.278,3.962,6.621,6.621,0,0,1-4.3-.034,4.373,4.373,0,0,1-2.27-5.383",
    transform: "translate(-212.925 -40.764)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.668,
    height: 25.068,
    transform: "translate(43.138 361.184)",
    fill: "#f8a8ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.427,505.82c-1.857,0-3.51-.042-4.756-.16-4.691-.43-9.171-3.9-11.424-5.923a3.2,3.2,0,0,1-.81-3.612h0a3.17,3.17,0,0,1,2.067-1.832l12.4-3.543L243.982,477.2l.228.4a35.787,35.787,0,0,1,2.717,6.1,2.715,2.715,0,0,1-.194,2.261,2.159,2.159,0,0,1-.933.776c.363.379,1.5,1.156,5.012,1.713,5.121.81,6.2-4.5,6.248-4.717l.034-.177.152-.1c2.439-1.569,3.941-2.286,4.455-2.134.321.093.861.262,2.32,14.715a14.856,14.856,0,0,1,.473,6.961c-.751,3.46-15.871,2.27-18.9,2-.084.008-11.407.819-19.161.819h-.008Z",
    transform: "translate(-200.501 -104.397)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.668,
    height: 25.068,
    transform: "translate(96.126 350.822) rotate(-31.95)",
    fill: "#f8a8ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.5,499.023a31.637,31.637,0,0,1-5.34-.49,3.211,3.211,0,0,1-2.6-2.633h0a3.171,3.171,0,0,1,.784-2.649L307,483.683l9.872-22.123.4.219a35.788,35.788,0,0,1,5.535,3.738,2.689,2.689,0,0,1,1.026,2.025,2.135,2.135,0,0,1-.379,1.156c.506.135,1.882.187,5.155-1.2,4.775-2.017,2.885-7.1,2.8-7.307l-.067-.169.076-.16c1.24-2.624,2.126-4.025,2.649-4.168.329-.093.869-.236,9.754,11.264a14.8,14.8,0,0,1,4.083,5.653c1.19,3.333-12.268,10.328-14.977,11.695-.084.067-14.167,10.3-19.956,13.213a16.851,16.851,0,0,1-7.484,1.511h0Z",
    transform: "translate(-214.303 -101.035)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.388,214.98h-49.47L222.429,261l19.642,170.034h25.253l-10.1-98.205,40.964,88.662,22.444-15.711L288.65,323.005s11.424-72.108,2.447-90.071-14.707-17.956-14.707-17.956h0Z",
    transform: "translate(-202.57 -63.427)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.993,199.491H222.43L245.995,97.92h34.233Z",
    transform: "translate(-202.57 -45.138)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.236,93.2c-1.257-6.176,1.046-11.821,5.129-12.606s8.412,3.595,9.661,9.771a15.33,15.33,0,0,1-.244,7.441l4.969,26.249-12.842,2.034L202.374,100a15.508,15.508,0,0,1-3.139-6.8Z",
    transform: "translate(-198.893 -42.416)",
    fill: "#f8a8ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.036,97.918H245.851l-20.351,40.7-7.678-30.5-16.866,1.789s3.991,59.594,21.431,57.578,58.118-55.7,53.646-69.576h.008Z",
    transform: "translate(-199.215 -45.136)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.276,275.28c1.257,6.176-1.046,11.822-5.129,12.606s-8.412-3.595-9.661-9.771a15.33,15.33,0,0,1,.244-7.442l-4.969-26.249,12.842-2.034,3.535,26.089a15.507,15.507,0,0,1,3.139,6.8Z",
    transform: "translate(-215.746 -67.71)",
    fill: "#f8a8ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.54,97.861s17.154-.725,18.048,0c4.683,3.823,32.148,141.785,32.148,141.785h-17.4Z",
    transform: "translate(-209.931 -45.078)",
    fill: "#2f2e43"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(606.503 502.092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.988,361.878l17.819,35.274,53.267,24.218c5.689,9.615,23.768,10.351,25.083,4.136,1.476-6.975-21.955-18.2-21.955-18.2l-44.559-30.139-3.9-25.946Z",
    transform: "translate(-746.5 -229.103)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.219,464.214,725.933,490.5l19.058,1.315,1.969-27.6Z",
    transform: "translate(-670.628 -94.732)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.991,677.545a51.6,51.6,0,0,1-4.7-5.751c-2.728-3.78-5.152,15.608-5.152,15.608s-2.629,7.886-1.969,11.829,15.771,3.943,18.4,3.288,15.771,0,15.771,0h19.715c17.087-7.886,0-13.143,0-13.143-5.258-.657-23-17.087-23-17.087l-3.943-7.229c-2.628-.657-5.258,9.2-5.258,9.2Z",
    transform: "translate(-804.773 -285.719)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.36,464.615,786.072,490.9l19.059,1.315,1.969-27.6Z",
    transform: "translate(-780.058 -94.804)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.126,677.947a51.653,51.653,0,0,1-4.7-5.751c-2.731-3.78-5.154,15.608-5.154,15.608s-2.628,7.229-1.969,11.172,15.771,3.939,18.4,3.288,15.771.657,15.771.657h19.715c17.087-7.886,0-13.144,0-13.144-5.258-.658-23-17.087-23-17.087l-3.943-7.229c-2.628-.657-5.258,9.2-5.258,9.2Z",
    transform: "translate(-914.194 -285.791)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.547,446.248c-2.629,3.288-1.314,14.458-1.314,14.458s-4.6,36.144-2.628,39.43-1.314,5.914-3.288,10.515-3.944,15.771-3.944,15.771c-11.172,9.2-10.515,51.259-10.515,51.259l-3.939,37.458c1.314,3.943,19.715,4.6,22.345,3.943s10.515-59.8,10.515-59.8l17.743-33.516s-1.314,89.374-1.314,93.32,17.743,1.969,21.686,1.969,3.943-65.717,3.943-65.717l3.943-17.085,21.03-78.2v-9.2l-3.288-4.6S889.175,442.962,886.547,446.248Z",
    transform: "translate(-855.557 -245.985)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.73,251.326c-4.129,9.2-1.685,22.042,6.576,36.144L895.79,271.7l5.258-4.6-1.311-13.141Z",
    transform: "translate(-852.639 -211.083)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.373,
    cy: 20.373,
    rx: 20.373,
    ry: 20.373,
    transform: "translate(39.531 10.343)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.238,275.827c4.389,2.609,7.014,7.4,8.521,12.282a116.4,116.4,0,0,1,5,27.807l1.591,28.253,19.715,74.918c-17.085,14.458-26.94,11.172-49.944-.657s-25.63,3.946-25.63,3.946-1.969-.657,0-2.628,0,0-1.969-1.969,0,0,.657-1.969,0-.658-.657-1.314,2.628-6.576,2.628-6.576l-5.255-49.29-6.576-69.659c7.886-9.858,30.228-18.4,30.228-18.4l20.376,14.458c6.576,2.628,1.314-7.886,1.314-7.886Z",
    transform: "translate(-843.147 -214.555)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.576,343.937l-2.628,39.43,33.519,47.973c0,11.172,5.914,13.8,5.914,13.8a86.859,86.859,0,0,0,5.914-11.172c3.288-7.229-1.969-13.143-1.969-13.143l-23-48.629,9.858-24.315Z",
    transform: "translate(-922.244 -227.791)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.6,293.123c-11.172,3.943-13.143,46.66-13.143,46.66,13.143-7.229,28.915,4.6,28.915,4.6s3.288-11.172,7.229-25.629a25.116,25.116,0,0,0-5.258-23.659S961.778,289.181,950.6,293.123Z",
    transform: "translate(-932.102 -218.378)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.824,31.062c2.266.295,3.975-2.023,4.766-4.167s1.4-4.637,3.366-5.795c2.692-1.581,6.134.321,9.211-.2,3.475-.589,5.734-4.272,5.913-7.792s-1.224-6.9-2.6-10.15L39,6.991A8,8,0,0,0,35.505,0l.616,5.918A6.282,6.282,0,0,0,28.9.721l.1,3.526A58.415,58.415,0,0,0,16.9,3.654,19.54,19.54,0,0,0,5.775,7.943C1.212,11.91-.455,18.439.1,24.459S3.148,36.135,5.739,41.6c.651,1.374,1.553,2.925,3.064,3.1a3.088,3.088,0,0,0,3.022-2.279,8.253,8.253,0,0,0-.037-4.055,17.21,17.21,0,0,1-.5-6.136c.358-2.033,1.822-4.043,3.871-4.291s4.147,2.094,3.162,3.911Z",
    transform: "translate(35.443 0)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.55,550.829l33.429-64.009a5.247,5.247,0,0,1,7.072-2.219l48.523,25.342a5.247,5.247,0,0,1,2.219,7.072l-33.429,64.009a5.247,5.247,0,0,1-7.072,2.219L300.769,557.9A5.247,5.247,0,0,1,298.55,550.829Z",
    transform: "translate(-173.513 -332.917)",
    fill: "#3f3d56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawQuestions52Ic);
export default __webpack_public_path__ + "static/media/undraw_questions_52ic.89c30cd18f84c2602bd3dbdb71fbb260.svg";
export { ForwardRef as ReactComponent };